<template>
    <b-modal
      v-model="isModalOpen"
      size="lg"
      @hidden="closeModal"
      hide-header
      hide-footer
    >
      <div class="custom-modal-header d-flex justify-content-between align-items-center" style="padding: 20px">
        <h5 class="modal-title font-16">{{ company }}</h5>
        <button 
          type="button" 
          class="close" 
          @click="closeModal"
          aria-label="Close"
          style="margin-right: 40px"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="jd-details" style="">
        <div class="jd-section jd-title-section">
          <h3>{{ jd.job_title }}</h3>
        </div>
  
        <div class="jd-section jd-info-section">
          <p v-html="jd.job_description"></p>
        </div>
      </div>
  
      <div class="custom-modal-footer" v-if="!isOtherNotifications">
        <div class="btn-container d-flex flex-column align-items-center" style="gap: 10px;">
          <b-button v-if="isQuestionRequest" class="custom-btn question-btn" disabled>質問する</b-button>
          <b-button class="custom-btn apply-btn" disabled>
            <span class="btn-main-text" v-html="applyButtonMainText"></span>
            <span class="btn-sub-text" v-if="contactType !== 'カジュアル面談'">回答画面に進みます</span>
          </b-button>
          <b-button class="custom-btn refrain-btn" disabled>
            <span class="btn-main-text">今回は控える</span>
            <span class="btn-sub-text" v-if="showDifferentPosition">別求人への希望も可能です</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'IndividualJDModal',
    
    props: {
      jd: {
        type: Object,
        required: true,
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      submitButtonText: {
        type: String,
        required: true
      },
      isOtherNotifications: {
        type: Boolean,
        default: false
      },
      isQuestionRequest: {
        type: Boolean,
        default: false
      },
      company: {
        type: String,
        required: true
      },
      showDifferentPosition: {
        type: Boolean,
        default: false
      },
      contactType: {
        type: String,
        default: '応募案内'
      }
    },

    computed: {
      applyButtonMainText() {
        if (this.contactType === '面接案内') return '面接に参加する';
        if (this.contactType === 'カジュアル面談') return 'カジュアル面談に<br/>参加する';
        return '応募する';
      },
      isModalOpen: {
        get() {
          return this.isOpen
        },
        set(value) {
          if (!value) {
            this.closeModal()
          }
        }
      }
    },

    methods: {
      closeModal() {
        this.$emit('closeJdModal')
      },
    },
  }
  </script>
  
  <style scoped>
  ::v-deep .modal-body {
      padding: 0px !important;
  }
  .font-16 {
      font-size: 16px;
  }
  .jd-section {
      text-align: left;
      padding: 30px 50px;
  }

  .jd-title-section {
      background: #ededed;
      height: 76px;
      padding: 30px 20px;
  }

  .jd-info-section {
      max-height: 450px;
      overflow-y: auto;
      padding: 20px;
  }

  .jd-info-section p {
      font-size: 14px;
  }

  .jd-section h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 14px;
  }

  .company {
    color: #666;
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }

  .custom-modal-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 2rem;
    background-color: #F2F5F7;
    border-top: 1px solid #dee2e6;
  }

  .custom-btn {
    border-radius: 4px !important;
    width: 325px;
    height: 60px;
    padding: 20px 25px;
  }

  .custom-btn:disabled {
    opacity: 1;
  }

  .question-btn {
    background-color: #2F80ED !important;
    border-color: #2F80ED !important;
    color: #fff !important;
  }

  .apply-btn {
    background-color: #006C6B !important;
    border-color: #006C6B !important;
    color: #fff !important;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .refrain-btn {
    background-color: #fff !important;
    border: 1px solid #000 !important;
    color: #000 !important;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .refrain-btn .btn-sub-text {
    color: #C0392B !important;
  }

  .btn-main-text {
    display: block;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .btn-sub-text {
    display: block;
    font-size: 11px;
    margin-top: 2px;
    font-weight: normal;
  }

  </style>
  